import { Injectable } from '@angular/core';
import * as R from 'ramda';

import { KPI } from '../api/models';

@Injectable()
export class InvestmentSlicesService {
  private byYear = R.groupBy((slice: KPI.InvestmentSlice) => `${slice.year}`);
  private byStatus = R.groupBy((slice: KPI.InvestmentSlice) => `${slice.status}`);

  constructor() { }

  /**
   * Create the InvestmentSlicesByYear using an investment
   *
   * @param investment
   */
  public getInvestmentSlicesByYearFromInvestment(investment: KPI.MappedInvestment): KPI.InvestmentSlicesByYear[] {
    const investmentSlicesByYearChanges: KPI.InvestmentSlicesByYear[] = [];
    const slicesByYear = this.byYear(investment.slices);
    for (const yearStr of Object.keys(slicesByYear)) {
      // Set the investment's status to slice if in case of null value
      const slices = slicesByYear[yearStr].map(slice => {
        if (!slice.status) {
          slice.status = investment.status;
          console.error('Found a slice with status as null on investment #' + investment.id);
        }
        return slice;
      });
      const slicesByStatus = this.byStatus(slices);
      const slicesByStatusNoArray: { [statusId: number]: KPI.InvestmentSlice } = {};

      for (const status of Object.keys(slicesByStatus)) {
        slicesByStatusNoArray[status] = slicesByStatus[status][0];
      }

      const year = parseInt(yearStr, 10);

      if (slicesByStatusNoArray[investment.status]) {
        investmentSlicesByYearChanges.push({
          investment,
          year: year,
          slicesByStatus: slicesByStatusNoArray,
          spendingSlice: investment.spending_slices.find((spSlc) => spSlc.year === year),
          budget: <number>slicesByStatusNoArray[investment.status].price,
          isExtraWork: slicesByStatusNoArray[investment.status].is_extra_work ? true : false,
        });
      }
    }

    return investmentSlicesByYearChanges;
  }
}
